import * as Yup from "yup";

export const immediateNeedSchema = Yup.object().shape({
  location: Yup.string().required("Location is required"),
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name cannot be more than 50 characters"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"),
  serviceType: Yup.number().required("Type of Service is required"),
});

export const preneedSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name cannot be more than 50 characters"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"),
  serviceType: Yup.number().required("Type of Service is required"),
  dateTime: Yup.string().required("Date & Time required"),
});